import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getPayload } from "../../actions"
import Title from "../general/title"
import moment from "moment"
import { withRouter } from "react-router-dom"
import _ from "lodash"
import { storePref, checkPref, removePref } from "helpers/pref"
import Modal from "react-responsive-modal"
import FullTable from "components/FullTable"
import { toast } from "react-toastify"
import helpers from "helpers/helpers"
import BuyerModal from "containers/entry/modals/buyer"
import currentUser from "helpers/currentUser"
import Switch from "react-switch"

class Paperwork extends Component {
	constructor(props) {
		super(props)
		let pref = checkPref("portal__lotInventory__filtered")
		let user = currentUser()
		this.state = {
			loading: true,
			valid: false,
			id: 0,
			transferModal: false,
			startModal: false,
			completeModal: false,
			closingModal: false,
			buyerModal: false,
			contractModal: false,
			bustoutModal: false,
			data: {},
			filtered: pref ? pref : [],
			modalStatus: false,
			modalData: "",
			currentUser: currentUser(),
			fullUser: _.find(this.props.payload.users, { id: user?.id }),
			missing: true,
		}
	}

	componentDidUpdate(prevProps) {
		if(!_.isEqual(prevProps.payload, this.props.payload)) {
			this.setFullUser()
		}
	}

	setFullUser = () => {
		let fullUser = _.find(this.props.payload.users, { id: this.state.currentUser.id })
		if (fullUser) {
			this.setState({
				fullUser,
			})
		}
	}

	getColumnWidth = (data, accessor, headerText) => {
		if (typeof accessor === "string" || accessor instanceof String) {
			accessor = (d) => d[accessor]
		}
		const maxWidth = 600
		const magicSpacing = 10
		const cellLength = Math.max(...data.map((row) => (`${accessor(row)}` || "").length), headerText.length)
		return Math.min(maxWidth, cellLength * magicSpacing)
	}

	buttonClick = (modal, data) => {
		data.sale_id = data.id
		this.setState({
			[modal]: true,
			data,
		})
	}

	buildTable = () => {
		let f = []
		try {
			let neighborhoods = []
			let manager = _.find(this.props.payload.users, { id: this.state.currentUser.id })
			if (
				!manager.manager_paperwork && // If this user is  paperwork, they can see all paperwork
				(!manager ||
					!manager.overSalespeople ||
					(manager.overSalespeople &&
						Array.isArray(manager.overSalespeople) &&
						manager.overSalespeople.length == 0))
			) {
				throw `Cannot find manager details or manager not over any salespeople.`
			}
			if (!manager.manager_paperwork) {
				_.forEach(manager.overSalespeople, (v) => {
					let sp = _.find(this.props.payload.users, { id: v })
					if (!sp) return
					if (Array.isArray(sp.neighborhoods) && sp.neighborhoods.length > 0) {
						neighborhoods.push(...sp.neighborhoods)
					}
				})
			}

			neighborhoods = _.uniq(neighborhoods)
			_.forEach(this.props.payload.salesManagerPayload.sales, (r) => {
				if (
					!this.props.activeProperties.includes(r.property) ||
					!r.documents ||
					r.bustout_date ||
					r.transfer_date
				) {
					return
				}
				if (!manager.manager_paperwork && neighborhoods.includes(r.neighborhood)) {
					return
				}
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let sec = _.find(this.props.payload.public.sections, { id: r.section_id })
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let section = sec ? sec.name : ""
				let community = _.find(this.props.payload.public.properties, { id: r.property })
				let ret = {
					section: section,
					block: r.block,
					lot: r.lot,
					builder: builder.name,
					address: r.address,
					buyer_last: r.primary_last,
					//buyer_first: r.primary_first,
					sale_date: r.sale_date,
					price: r.price,
					closing_date: r.closing_date,
					community: community && community.name,
					documents: r.documents,
					salesperson: sp ? `${sp.first} ${sp.last}` : "",
					actions: null,
				}
				let status = true // meaning all good
				_.forEach(r.documents, (v) => {
					let doc = _.find(this.props.payload.public.options.docs, { dbName: v.type })
					if (v.status == "accepted") {
						ret[v.type] = v.approved_date
					} else if (v.status == "rejected") {
						status = false
						ret[v.type] = (
							<button
								className="btn red"
								onClick={() => {
									this.setState({
										modalStatus: true,
										modalData: (
											<>
												<h1>Paperwork Rejection</h1>
												<table className="rejectionTable">
													<tbody>
														<tr>
															<td>Address</td>
															<td>{r.address}</td>
														</tr>
														<tr>
															<td>Document</td>
															<td>{doc.name}</td>
														</tr>
														<tr>
															<td>Reason</td>
															<td>{v.reason}</td>
														</tr>
													</tbody>
												</table>
											</>
										),
									})
								}}>
								Rejected
							</button>
						)
					} else if (v.status == "awaiting" || v.status == "pending") {
						status = false
					}
					if (["awaiting", "rejected"].includes(v.status) && manager?.manager_paperwork) {
						ret.actions = (
							<button className={`btn`} onClick={() => this.buttonClick("buyerModal", r)}>
								Buyer Paperwork
							</button>
						)
					}
				})
				// If the row is status = true, and it's past 1 week, do not add.
				if (status && r.closing_date) {
					let week = moment().subtract(1, "week").unix()
					if (r.closing_date < week) {
						return
					}
				}
				if (this.state.missing && status) return
				f.push(ret)
			})
		} catch (e) {
			console.error(e)
		}

		return f
	}

	renderInventory = () => {
		let rows = this.buildTable()
		let assignedDocs = []
		_.forEach(this.props.activeProperties, (v) => {
			try {
				let property = _.find(this.props.payload.public.properties, { id: v })
				if (!property) throw new Error("Cannot find property")
				_.forEach(property.assigned_docs, (v) => {
					assignedDocs.push(v)
				})
			} catch (e) {
				console.log(e)
			}
		})
		assignedDocs = _.uniq(assignedDocs)
		let docColumns = _.map(assignedDocs, (v) => {
			try {
				let doc = _.find(this.props.payload.public.options.docs, { id: v })
				if (!doc) throw new Error("Cannot find doc.")
				return {
					Header: doc.name,
					accessor: doc.dbName,
					filterable: false,
					Cell: (props) => {
						if (typeof props.value == "number") {
							return moment.unix(props.value).format("MM/DD/YY")
						} else if (props.value) {
							return props.value
						} else return ""
					},
				}
			} catch (e) {
				console.log(e)
			}
		})
		const columns = [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => {
					if (r._original.builder && r._original.builder.toLowerCase().includes(f.value.toLowerCase())) {
						return true
					}
				},
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => {
					if (
						r._original.salesperson &&
						r._original.salesperson.toLowerCase().includes(f.value.toLowerCase())
					) {
						return true
					}
				},
			},
			{
				Header: "Section",
				accessor: "section",
				width: this.getColumnWidth(rows, "section", "Section"),
				filterMethod: (f, r) => helpers.tableText(f, r, "section"),
			},
			{
				Header: "Block",
				accessor: "block",
				width: this.getColumnWidth(rows, "block", "Block"),
			},
			{
				Header: "Lot",
				accessor: "lot",
				width: this.getColumnWidth(rows, "lot", "Lot"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Buyer Last",
				accessor: "buyer_last",
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer_last"),
			},
			{
				Header: "Contract Date",
				accessor: "sale_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Closing Date",
				accessor: "closing_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Buyer Profile",
				accessor: "profile",
				filterable: false,
				Cell: (props) => {
					if (typeof props.value == "number") {
						return moment.unix(props.value).format("MM/DD/YY")
					} else if (props.value) {
						return props.value
					} else return ""
				},
				maxWidth: 125,
			},
		]
		if (this.state.fullUser?.manager_paperwork) {
			columns.push({
				Header: "Actions",
				accessor: "actions",
				filterable: false,
			})
		}
		columns.push(...docColumns)
		return (
			<div>
				<ul className="legend__list" style={{ paddingLeft: 0 }}>
					<li>
						<span className="statusColor--awaiting" /> Awaiting Paperwork
					</li>
					<li>
						<span className="statusColor--pending" /> Pending Approval
					</li>
					<li>
						<span className="statusColor--rejected" /> Rejection
					</li>
					<li>
						<span className="statusColor--approved" /> Approved Paperwork
					</li>
				</ul>
				<div className="switch" onClick={(e) => e.stopPropagation()}>
					<Switch
						onChange={() => this.setState({ missing: !this.state.missing })}
						checked={this.state.missing}
						checkedIcon={false}
						uncheckedIcon={false}
						key={"paperworkSwitch"}
						id={"paperworkSwitch"}
					/>
					<p>Showing {this.state.missing ? "Missing Paperwork" : "All Paperwork"}</p>
				</div>
				<FullTable
					data={this.buildTable()}
					columns={columns}
					name="salesManager__paperwork"
					title="Paperwork"
					unset={["documents"]}
					classNames={"small"}
					defaultSorted={[
						{
							id: "sale_date",
							desc: true,
						},
					]}
					excelClean={this.excelClean}
					getTrProps={this.getTrProps}
				/>
			</div>
		)
	}

	notify = (d, name) => {
		//return
		if (d.status == 200) {
			toast.success(d.message)
			this.setState({
				[name]: false,
			})
			this.props.getPayload()
		} else {
			toast.error(d.message)
		}
	}

	excelClean = (data) => {
		// This goes through and find all the react buttons in the table rows and turns them simply into "rejected".  rejected is the only react button, so we can get away with easy transformation.
		let ret = []
		_.forEach(data, (v, ind) => {
			_.forEach(v._original, (r, k) => {
				if (r && typeof r === "object") {
					data[ind]._original[k] = "Rejected"
				}
			})
			ret.push(v)
		})
		return ret
	}

	getTrProps = (state, rowInfo, instance) => {
		if (rowInfo) {
			let v = rowInfo.original
			let className = ""
			if (v.documents && v.documents.length > 0) {
				let rejects = _.find(v.documents, { status: "rejected" })
				let awaiting = _.find(v.documents, { status: "awaiting" })
				let pending = _.find(v.documents, { status: "pending" })
				let allApproved = false
				if (!pending && !awaiting && !rejects) {
					allApproved = true
					_.forEach(v.documents, (r) => {
						if (r.status !== "accepted") {
							allApproved = false
						}
					})
				}
				// Order matters here
				// Pending is above awaiting simply due to the fact that some people submit combined documents
				if (rejects) {
					className = "statusColor--rejected"
				} else if (pending) {
					className = "statusColor--pending"
				} else if (awaiting) {
					className = "statusColor--awaiting"
				} else if (allApproved) {
					className = "statusColor--approved"
				}
			} else if (!v.documents && v.sale_date) {
				className = "statusColor--awaiting"
			}
			return {
				className: className,
			}
		}
		return {}
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="lotInventory">
					<div className="imageGroup">
						<Title title="Paperwork" showDate={false} />
						<div className="content">{this.renderInventory()}</div>
					</div>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.modalStatus}
						onClose={() => this.setState({ modalStatus: false })}
						center>
						{this.state.modalData}
					</Modal>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.buyerModal}
						onClose={() => this.setState({ buyerModal: false })}
						center>
						<BuyerModal data={this.state.data} notify={this.notify} name="buyerModal" />
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		trafficSources: state.trafficSources,
		activeProperties: state.activeProperties,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(Paperwork))
